<!--首页-->
<template>
  <div class="index">

    <el-image aria-hidden="true" style="width: 40%;float: right;margin-right: 7%;margin-top: 3%" role="text"
              src="/static/image/封面/研究会白.png?v=2"></el-image>

    <div>

      <div class="area">
        <p tabindex="1" id="title-p" role="text" aria-label=" 一二三，无障爱主题海报，测一测你的无障碍人格类型，在线匹配你的专属好朋友">
          <el-image class="imgs"
                    :src="titlehd"></el-image>
        </p>
      </div>
      <div class="start">
        <el-button aria-label="交个朋友" type="primary" @click="StartToExperience()">
          <el-image class="hand animate__animated animate__flash animate__infinite animate__slow" aria-hidden="true"
                    :src="hand"></el-image>
        </el-button>
      </div>
    </div>

  </div>




</template>


<script>

import 'animate.css';
import $ from "jquery"
import Common from "../utils/Common";

export default {
  name: 'index',
  data() {
    return {
      height1: 0,
      // 头图
      titlehd: '/static/image/封面/BANNER.png?v=2',
      hand: '/static/image/封面/手.png?v=2',
    }
  },
  created() {


  },
  mounted() {


    // 获取元素距离顶部的距离跟可视区域的高度
    const h = screen.height
    const w = screen.width
    console.log(h)
    if (w >= 500) {
      $(".area").css({"width":"70%","margin-left":"15%","padding-top":"30%"})
    }else{
      if (h<=700){
        $(".area").css({"padding-top":"30%"})
        $(".start").css({"margin-top": "5%"})
      }
    }



    this.$nextTick(function () {

        document.getElementById('title-p').focus()
        if (Common.nickname === '') {
          const wx = window.wx;
          let herf = window.sessionStorage.getItem('firstEntryUrl').split('#')[0]
          let code = herf.substring(herf.indexOf("code=") + 5, herf.indexOf("&state"))
          this.axios({
            method: "post",
            url: "https://accloveapi.siaa.org.cn/get_wx_config",
            data: {
              url: window.sessionStorage.getItem('firstEntryUrl').split('#')[0]
            }
          }).then((res) => {
            // 配置微信注入信息
            wx.config({ //  通过后端
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
              appId: 'wx6c0a281d3ef4bb03', // 必填，公众号的唯一标识
              timestamp: res.data.t, // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.sign, // 必填，签名
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
          })
          // 拉取用户信息
          this.axios({
            method: 'get',
            url: 'https://accloveapi.siaa.org.cn/get_userinfo?code=' + code
          }).then((res) => {
            this.nickname = res.data['nickname']
            this.headimgurl = res.data['headimgurl']
            Common.nickname = this.nickname
            Common.headimgurl = this.headimgurl
            // localStorage.setItem("nickname", res.data['nickname'])
            // localStorage.setItem("headimgurl", res.data['headimgurl'])
          })
        }
        wx.ready(function () {
          // 分享到朋友圈
          wx.updateTimelineShareData({
            title: '测一测你的“无障爱”人格类型，在线匹配你的专属好朋友', // 分享标题
            link: 'https://accloveapi.siaa.org.cn/authorization', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://acclove-h5-1251451172.cos.ap-guangzhou.myqcloud.com/20311638017450_.pic_hd.jpg', // 分享图标
            success: function () {
              // 设置成功
            }
          })

          // 分享给好友
          wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
              title: '测一测你的“无障爱”人格类型，在线匹配你的专属好朋友', // 分享标题
              desc: '我的专属朋友竟然是...', // 分享描述
              link: 'https://accloveapi.siaa.org.cn/authorization', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: 'https://acclove-h5-1251451172.cos.ap-guangzhou.myqcloud.com/20311638017450_.pic_hd.jpg', // 分享图标
              success: function () {
                // 设置成功
              }
            })


          });


        });

        wx.error(function (res) {

        });


      }
    )
  },
  computed: {
    scrollerHeight: function () {
      return (window.innerHeight - 50) + 'px'
    }
    ,
    scrollerHeight1: function () {
      return (window.innerHeight - 51) + 'px'
    }
    ,
  }
  ,
  methods: {

    StartToExperience() {
      this.$router.replace('/problem1')


    }
    ,

  }

}
</script>


<style scoped>


/* 开始体验 */
.start {
  /*background: aquamarine;*/
  text-align: center; /*水平居中*/
  margin-bottom: 20%;
  /*position: relative;*/
  margin-top: 15%;
  /*display:inline-block;*/
}

.hand {
  width: 50px;
  float: right;
  margin-right: -15px;

}


.imgs {
  /*pointer-events: none;*/
}

p {
  outline: none;
}

.index {
  width: 100%;
  height: 100vh;
  background-image: url("/static/image/封面/BG.png?v=2");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}


.area {
  width: 100%;
  /*height: 100px;*/
  /*margin: 0 auto;*/
  /*position: relative;*/
  padding-top: 50%;
  /*transform: translateY(-35%);*/
}

.el-button {
  width: 200px;
  height: 60px;
  background: url("/static/image/封面/按钮.png?v=2");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/components/home/game.vue